import React, { useContext, useState } from "react";
import SearchFormContent from "../../../components/view/flight/international/search-form-content";
import { LocaleContext } from "../../../routing/LangRouter";

function IntFlightSearch() {
    const { locale } = useContext(LocaleContext);
    const [uid, setUid] = useState();
    const [requestFlag, setRequestFlag] = useState(false);

    return <SearchFormContent setRequestFlag={setRequestFlag} setUid={setUid} intFlightRoute={`/${locale}/international-flight`} />;
}

export default IntFlightSearch;
